// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__bP6CG","validationTips":"StatementDescriptor_validationTips__2GRoQ"};